import React from 'react'

const CredentialSignIn = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" {...r}>
      <path
        fill="#00033A"
        d="M32.415 4.103A3.375 3.375 0 0029.039.727H12.927A3.376 3.376 0 009.55 4.103l-.096 36.15a3.377 3.377 0 003.376 3.376H22v-1.368l-9.19-.006a2.048 2.048 0 01-2.048-2.05l.123-36.118c0-1.13.918-2.047 2.05-2.046l1.864.001c.394 0 .54 0 .564.5.023.519.38.837.862.988.082.026 2.43.04 4.78.042h1c1.974-.001 3.71-.012 3.78-.034.483-.151.84-.468.866-.987.024-.5.169-.5.563-.5l1.848.002c1.13 0 2.047.918 2.046 2.05L31.013 32h1.327l.075-27.897z"
      ></path>
      <path
        fill="#00033A"
        stroke="#00033A"
        strokeWidth="0.3"
        d="M24.188 27.296c1.147-.877 1.828-2.215 1.828-3.835v-2.497c0-1.215-.608-2.362-1.552-2.902-1.011-.608-2.295-.608-2.361-.608h-2.565a3.455 3.455 0 00-3.44 3.442v2.497c0 1.552.74 2.97 1.889 3.847-.472.203-1.08.473-1.62 1.08-1.215 1.216-1.822 3.105-1.822 5.669 0 .27.27.54.54.54s.54-.27.54-.54c0-4.52 2.092-5.534 3.172-5.804v.742c0 1.011.81 1.89 1.888 1.89h.945c1.012 0 1.89-.81 1.89-1.89v-.742c1.08.338 3.037 1.485 3.037 5.804 0 .27.27.54.54.54s.54-.27.54-.54c0-2.565-.76-5.793-3.45-6.693zm-6.945-3.768V21.03c0-1.281 1.08-2.36 2.361-2.36h2.565c.068 0 1.012 0 1.822.47.608.339 1.011 1.08 1.011 1.958v2.498a3.845 3.845 0 01-3.847 3.846c-2.091 0-3.912-1.821-3.912-3.914zm4.32 6.276h-.945a.78.78 0 01-.81-.81v-.741c.404.135.81.202 1.281.202.473 0 .878-.068 1.283-.202v.741c0 .473-.337.81-.81.81z"
      ></path>
      <path
        stroke="#126FFF"
        strokeLinecap="round"
        strokeWidth="1.6"
        d="M25.678 13.196h-9.469a1.988 1.988 0 010-3.975h9.469a1.987 1.987 0 110 3.975z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#126FFF"
        fillRule="evenodd"
        d="M19.072 11.208a.773.773 0 11-1.546-.002.773.773 0 011.546.002zm2.551 0a.772.772 0 11-1.544 0 .772.772 0 011.544 0zm2.551 0a.773.773 0 11-1.547-.002.773.773 0 011.547.002z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#126FFF"
        strokeWidth="1.6"
        d="M32.414 32.217a2.11 2.11 0 00-.306.084l-10.092 3.536c-1.082.38-1.673 1.534-1.315 2.573l2.033 5.912c.323.941 1.317 1.47 2.307 1.278.102-.02.204-.047.305-.082l10.092-3.537c1.083-.38 1.673-1.534 1.315-2.573l-2.032-5.911c-.325-.943-1.318-1.472-2.307-1.28z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#126FFF"
        fillRule="evenodd"
        stroke="#126FFF"
        strokeWidth="0.7"
        d="M26.333 39.332l-.007.002a.196.196 0 01-.244-.133.933.933 0 00-.459-.57.99.99 0 00-1.328.384.942.942 0 00-.09.73c.03.104-.022.206-.138.243a.196.196 0 01-.245-.133 1.332 1.332 0 01.127-1.027c.18-.317.47-.547.827-.65a1.377 1.377 0 011.042.11c.32.172.549.457.647.803a.198.198 0 01-.132.24zm6.627-1.916l-.007.002a.196.196 0 01-.244-.132.935.935 0 00-.46-.571.977.977 0 00-.74-.077.966.966 0 00-.587.46.941.941 0 00-.09.73c.029.104-.025.22-.139.244a.196.196 0 01-.245-.133 1.333 1.333 0 01.128-1.027c.181-.317.485-.546.827-.65a1.376 1.376 0 011.042.11c.32.172.549.458.647.803a.198.198 0 01-.132.24zm-3.492 4.069a1.672 1.672 0 01-1.8-.487.194.194 0 01.024-.276.2.2 0 01.28.02c.316.365.808.517 1.285.398a1.29 1.29 0 00.971-1.038.203.203 0 01.23-.164c.108.017.18.116.162.223a1.698 1.698 0 01-1.152 1.324z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default CredentialSignIn